// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2RmUt","info":"PatientInfo_info__1qeLM"};